import * as React from 'react'

import { cn } from '../cn'

/**
 * Standard page header used across every Ordo admin/data page. Title (H1),
 * optional subtitle, and right-aligned action buttons.
 */

export interface PageHeaderProps {
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
  className?: string
}

export function PageHeader({ title, subtitle, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between md:gap-4', className)}>
      <div className="min-w-0">
        <h1 className="text-2xl font-bold">{title}</h1>
        {subtitle != null && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {actions != null && <div className="flex flex-wrap items-center gap-2 md:flex-nowrap md:shrink-0">{actions}</div>}
    </div>
  )
}
